var React = require('react');
var ReactNative = require('react-native');

var Globals = require('./Globals');
var NetworkManager = require('./NetworkManager.js');
var ModelConstants = require('./constants/ModelConstants.js');
var ReUpScrollView = require('./ReUpScrollView.js');
var ReUpButton = require('./ReUpButton.js');
var ReUpField = require('./ReUpField.js');
var ReUpIconButton = require('./ReUpIconButton.js');
var ReUpText = require('./ReUpText');
var LinkingManager = require('./wrappers/LinkingManager');
var createReactClass = require('create-react-class');
import Icon from './wrappers/ReUpIcon';

var MK = require('./wrappers/react-native-material-kit-wrapper');
var {
  MKColor,
  MKCardStyles,
  MKTextField,
  MKIconToggle
} = MK;

var {
  AppRegistry,
  Text,
  View,
  Image,
  ScrollView,
  Platform,
  StyleSheet,
} = ReactNative;

var RNFS = require('./wrappers/react-native-fs');
import Camera from './wrappers/react-native-camera-wrapper';

function findGetParameter(parameterName)
{
  var result = null,
    tmp = [];
  location.search
    .substr(1)
    .split("&")
    .forEach(function (item)
    {
      tmp = item.split("=");
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    });

  return result;
}

var SimpleSettings = createReactClass(
{
  getDefaultProps : function()
  {
    return {
      appManager : null,
    }
  },

  getInitialState : function()
  {
    return {
      layout : this.props.initialLayout,
      user : this.props.appManager.currentUser(),
      showPassword : false,
      selfieURL : null,
      hasOptedInForEmail : this.props.appManager.isLoggedIn() && this.props.appManager.currentUser()["hasOptedInForEmail"]
    }
  },

  componentDidMount : function()
  {
    var settings = this;
    this.props.appManager.getCurrentUser(function(user)
    {
      settings.props.appManager.getSelfie(function(selfieURL)
      {
        settings.setState({user:user,selfieURL:selfieURL});
      })
    });

    this.refreshUser();
  },

  logoutPressed : function()
  {
    var appActions = this.props.appActions;
    var thisThing = this;
    appActions.setSpinnerShown(true, "Logging out...");
    this.props.appManager.logout(function()
    {
      appActions.setSpinnerShown(false);
      appActions.requestPop();
    });
  },

  _camera : null,
  _canCapture : false,
  cameraDidLoad : function(camera)
  {
    if( !camera ) return;
    this._canCapture = true;
    this._camera = camera;
  },

  takePicture : async function()
  {
    if( this._camera && this._canCapture )
    {
      this._canCapture = false;
      try
      {
        var appManager = this.props.appManager;
        var thisThing = this;
        var data = await this._camera.capture({target:Camera.constants.CaptureTarget.disk, mode:Camera.constants.CaptureMode.still, type:Camera.constants.Type.front, quality:'medium'});
          // console.log(data);
        appManager.setSelfie(data, function()
        {
          // console.log("did set selfie")
          appManager.getSelfie(function(selfieURL)
          {
            // console.log("did get selfie with url" + selfieURL)
            thisThing.props.appActions.hideAlert();
            thisThing.setState({selfieURL:selfieURL})
            thisThing.props.appManager._eventEmitter.emit("checkUserChanged", {});
          })
        });
      } catch (e) {
        console.error(e);
      }
    }
  },

  didUpdate: function()
  {

  },

  profilePicSelected : function()
  {
    if( Platform.OS === 'ios' )
    {
      var thisThing = this;
      var appActions = this.props.appActions;
      Camera.checkVideoAuthorizationStatus().then((hasPermission)=>
      {
        if( hasPermission )
        {
          thisThing.showCamera();
        }
        else
        {
          appActions.showAlert("Camera Permission Required","You have not granted permission to use the camera. Please go into your phone's Settings and add the permission.",["Okay"],[function(){appActions.hideAlert();}]);
        }
      })
    }
    else
    {
      this.showCamera();
    }
  },

  showCamera : function()
  {
    var cameraDim = Math.min(this.state.layout.width,this.state.layout.height) - 20;
    var thisThing = this;
    var appManager = thisThing.props.appManager;

    var customAlert = Platform.OS === 'ios' ?
        <ScrollView bounces={true} style={{margin:0,padding:0}}
          keyboardShouldPersistTaps={true}
          keyboardDismissMode={"interactive"}>
          <Camera ref={this.cameraDidLoad} style={{alignSelf:'center', height:cameraDim,width:cameraDim, justifyContent:'flex-end', padding:10}}
            captureAudio={false}
            captureQuality={"medium"}
            captureTarget={Camera.constants.CaptureTarget.disk}
            type={Camera.constants.Type.front}
            aspect={Camera.constants.Aspect.Fill}>
            <ReUpIconButton iconName={"camera"} type={1} style={{margin:10}}
              appManager={appManager}
              style={{alignSelf:'flex-end'}}
                onPress={() => {
                  thisThing.takePicture();
                }}
                />
          </Camera>
        </ScrollView>
      :
        <ScrollView bounces={true} style={{margin:0,padding:0,paddingBottom:10}}
          keyboardShouldPersistTaps={true}
          keyboardDismissMode={"interactive"}>
          <Camera ref={this.cameraDidLoad} style={{alignSelf:'center', height:cameraDim,width:cameraDim, justifyContent:'flex-end', padding:10, marginBottom:10}}
            captureAudio={false}
            aspect={Camera.constants.Aspect.Fill}
            captureTarget={Camera.constants.CaptureTarget.disk}
            captureQuality={"medium"}
            type={Camera.constants.Type.front}
            orientation={Camera.constants.Orientation.portrait}>
          </Camera>
          <ReUpIconButton iconName={"camera"} type={1} style={{margin:10}}
            appManager={appManager}
            style={{alignSelf:'flex-end'}}
              onPress={() => {
                thisThing.takePicture();
              }}
              />
        </ScrollView>;
    this.props.appActions.setCustomAlertShown(true,customAlert);
  },

  changePasswordPressed : function()
  {
    this._showPassword = false
    this._currentPassword = "";
    this._newPassword = "";
    this._currentPasswordError = false;
    this._newPasswordError = false;

    this.showChangePass();
  },

  _showPassword : false,
  _currentPassword : "",
  _newPassword : "",
  _currentPasswordError: false,
  _newPasswordError: false,
  showChangePass : function()
  {
    var thisThing = this;
    var appManager = thisThing.props.appManager;
    var appActions = thisThing.props.appActions;
    var locManager = thisThing.props.appManager.getLocalizationManager();
    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
    var generalColor = 'white';//appManager.getColorForKey("GeneralColor");
    var generalTitleColor = 'black';//appManager.getColorForKey("GeneralTitleColor");
    var bannerColor = 'black';//appManager.getColorForKey("FeedCardBannerColor");

    var locMan = appManager.getLocalizationManager();
    var changePasswordButton = locMan.localizedStringForKey("CHANGE_PASSWORD_BUTTON");
    var newPassDescription = locMan.localizedStringForKey("CHANGE_PASSWORD_LABEL");
    var passPlaceholder = locMan.localizedStringForKey("CURRENT_PASSWORD_PLACEHOLDER");
    var newPassPlaceholder = locMan.localizedStringForKey("NEW_PASSWORD_PLACEHOLDER");
    var currPass = appManager.currentUser()[ModelConstants.Password];

    var customAlert =
      <ScrollView key="changepassscroll" bounces={true} style={{margin:0,padding:2,marginLeft:10,marginRight:10,flexBasis: 'auto', height:225}}
        keyboardShouldPersistTaps={true}
        keyboardDismissMode={"interactive"}>
        <View style={{flexDirection:'column'}}>
          <ReUpText appManager={appManager} style={{marginTop:10, textAlign:'center'}}>
            {newPassDescription}
          </ReUpText>
          <ReUpField appManager={appManager}
            key="oldPassword"
            tintColor={bannerColor}
            highlightColor={bannerColor}
            onChangeText={(text) => {this._currentPassword = text}}
            placeholder={passPlaceholder}
            secureTextEntry={true}/>
          <View style={{alignSelf:'stretch'}}>
            <ReUpField
              onChangeText={(text) => {this._newPassword = text}}
              key="password"
              ref={(a) => thisThing._passwordField = a}
              tintColor={bannerColor}
              highlightColor={bannerColor}
              appManager={appManager}
              placeholder={newPassPlaceholder}
              secureTextEntry={!this._showPassword}
              style={[{flex:1, alignSelf:'stretch', height:50}]}/>

            <MKIconToggle
              style={{marginTop:22, height:30, width:30, position:'absolute', right:0, backgroundColor:'transparent'}}
              checked={this._showPassword}
              onCheckedChange=
              {
                (info) => {
                  thisThing._passwordField.onBlur();
                  thisThing._showPassword = info.checked;
                  thisThing.showChangePass();

                }
              }
              >
              <Icon pointerEvents="none" state_checked={true} style={[styles.creditCardEditButtonIcon]} name={"eye"} size={14} color={generalTitleColor} />
              <Icon pointerEvents="none" state_checked={false} style={[styles.creditCardEditButtonIcon]} name={"eye-slash"} size={14} color={generalTitleColor} />
            </MKIconToggle>

          </View>
          <ReUpButton key="changepassbutton" onPress={() =>
            {
              if( thisThing._currentPassword.length <= 0 || thisThing._newPassword.length <= 0 ) return;

              if( currPass != thisThing._currentPassword )
              {
                var title = locManager.localizedStringForKey("ERROR_FAIL_ALERT_TITLE");
                var body = locManager.localizedStringForKey("PASSWORD_INCORRECT_BODY");
                var button = locManager.localizedStringForKey("OK_ALERT_BUTTON");
                appActions.showAlert(title,body,[button],[thisThing.showChangePass], function(){})
              }
              else if( appManager.isValidPassword(thisThing._newPassword) )
              {
                thisThing.changePassword(thisThing._newPassword);
              }
              else
              {
                appActions.showLocalizedAlert("CHANGE_PASS_FORMAT_FAIL_ALERT_TITLE","CHANGE_PASS_FORMAT_FAIL_ALERT_BODY",["OK_ALERT_BUTTON"],[()=>
                {
                  thisThing.props.appActions.hideAlert();
                  thisThing.showChangePass();
                }], function(){})
              }
            }} appManager={this.props.appManager} text={changePasswordButton} style={[styles.logoutButton, {marginTop:20, marginBottom:10}]} />
        </View>
      </ScrollView>;
    this.props.appActions.setCustomAlertShown(true,customAlert);
  },

  changePassword: function(newPass)
  {
    var thisThing = this;
    var appManager = thisThing.props.appManager;
    var locMan = appManager.getLocalizationManager();
    var changingPassword = appManager.getLocalizationManager().localizedStringForKey("SAVING_HUD");
    thisThing.props.appActions.setSpinnerShown(true, changingPassword)
    NetworkManager.changePassword(this.props.appManager, newPass, function()
    {
      thisThing.props.appActions.setSpinnerShown(false);
      var user = appManager.getCurrentUser(function(currentUser)
      {
        currentUser[ModelConstants.Password] = newPass;
        appManager.setCurrentUser(currentUser, function()
        {
          var changePassSuccessTitle = locMan.localizedStringForKey("CHANGE_PASS_SUCCESS_ALERT_TITLE");
          var changePassSuccessBody = locMan.localizedStringForKey("CHANGE_PASS_SUCCESS_ALERT_BODY");
          var okayButton = locMan.localizedStringForKey("OK_ALERT_BUTTON");

          thisThing.props.appActions.showAlert(changePassSuccessTitle, changePassSuccessBody, [okayButton], [function(){thisThing.props.appActions.hideAlert()}], function(){})
        });
      })
    }, function(data)
    {
      thisThing.props.appActions.setSpinnerShown(false);
      var title = locMan.localizedStringForKey("CHANGE_PASS_FAIL_ALERT_TITLE");
      var body = locMan.localizedStringForKey("CHANGE_PASS_FAIL_ALERT_BODY");
      var okayButton = locMan.localizedStringForKey("OK_ALERT_BUTTON");

      thisThing.props.appActions.showAlert(title, body, [okayButton], [function(){thisThing.showChangePass()}], function(){})
    }, function()
    {
      thisThing.props.appActions.setSpinnerShown(false);
      thisThing.props.appActions.showNetworkErrorAlert(function(){thisThing.showChangePass()}, function(){});
    },)
  },

  contactSupport: function()
  {
    var email = "hello@getreup.com";
    var platform = Platform.OS;
    if( platform == "android" ) platform = "Android";
    var subject = this.props.appManager.appNameLong + " Support";
    var body = "Hi, my email is " + this.props.appManager.currentUser()[ModelConstants.UserName] + " and I am on " + platform + ". I am having an issue with...";
    var url = "mailto:"+encodeURI(email)+"?subject="+encodeURI(subject)+"&body="+encodeURI(body);
    LinkingManager.canOpenURL(url, function(can)
    {
      if( can )
      {
        LinkingManager.openURL(url)
      }
    });
  },

  showTerms: function()
  {
    var tosLink = this.props.appManager.getTermsLink();
    LinkingManager.openURL(tosLink)
  },

  refreshUser: function()
  {
    var appManager = this.props.appManager;
    var userID = appManager.currentUser()[ModelConstants.UserID];
    var hash = appManager.currentUser()[ModelConstants.Hash];
    var thisThing = this;
    console.log("refreshinguser", userID, hash)
    NetworkManager.getUser(appManager, userID, hash, (data)=>
    {
      thisThing.setState({hasOptedInForEmail:data["HasOptedInForEmail"]});
      appManager.setCurrentUser(data);
    }, ()=>
    {
      console.log("couldn't refresh user")
    })
  },

  unsubscribe: function()
  {
    var appActions = this.props.appActions;
    var appManager = this.props.appManager;
    var userID = appManager.currentUser()[ModelConstants.UserID];

    var hash = appManager.currentUser()[ModelConstants.Hash];
    var thisThing = this;
    appActions.showLocalizedAlert("UNSUBSCRIBE_CONFIRMATION_ALERT_TITLE","UNSUBSCRIBE_CONFIRMATION_ALERT_BODY",["UNSUBSCRIBE_CONFIRMATION_ALERT_NO_BUTTON", "UNSUBSCRIBE_CONFIRMATION_ALERT_CONFIRM_BUTTON"],
      [function(){appActions.hideAlert();}, function()
      {
        thisThing.setState({hasOptedInForEmail:false});
        appActions.hideAlert();
        NetworkManager.optOutEmail(appManager, userID, hash, ()=>
        {
          thisThing.refreshUser();
        }, ()=>
        {

        })
      }]);
  },

  subscribe: function()
  {
    var appManager = this.props.appManager;
    var userID = appManager.currentUser()[ModelConstants.UserID];
    var hash = appManager.currentUser()[ModelConstants.Hash];
    var thisThing = this;
    console.log("subscribe", userID, hash);
    NetworkManager.optInEmail(appManager, userID, hash, ()=>
    {
      thisThing.setState({hasOptedInForEmail:true});
      thisThing.refreshUser();
    }, ()=>
    {

    })
  },

  render: function()
  {
    var appManager = this.props.appManager;
    var feedFeatureData = appManager.getFeatureForName("Feed");
    var bgImage = appManager.absoluteResourceForPath(feedFeatureData.data.name + "/" + feedFeatureData.data.bgImage);

    if( this.state.user == null || !this.props.appManager.isLoggedIn() ) // early return if we dont have the user yet
    {
      return (
        <View style={styles.container}>
          <Image
            style={[styles.image,{width:this.state.layout.width, height:this.state.layout.height}]}
            source={{uri: bgImage}}
          />
        </View>
      )
    }

    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var locManager = this.props.appManager.getLocalizationManager();

    var logoutButton = locManager.localizedStringForKey("LOGOUT_BUTTON");

    var cardColor = appManager.getColorForKey("FeedCardColor");
    var bannerColor = appManager.getColorForKey("FeedCardBannerColor");
    var bannerIconColor = appManager.getColorForKey("FeedCardBannerIconColor");
    var titleColor = appManager.getColorForKey("FeedCardTitleColor");
    var bodyColor = appManager.getColorForKey("FeedCardBodyColor");
    var profileColor = appManager.getColorForKey("ProfileColor");
    var profileTitleColor = appManager.getColorForKey("ProfileTitleColor");
    var profileMeterColor = appManager.getColorForKey("ProfileMeterColor");
    var profileMeterBackgroundColor = appManager.getColorForKey("ProfileMeterBackgroundColor");
    var profileIconColor = appManager.getColorForKey("ProfileIconColor");
    var profileImageColor = appManager.getColorForKey("ProfileImageColor");
    var profileImageColorLight = appManager.getColorForKey("ProfileImageColor", .2);
    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");

    var user = this.state.user;
    var userFullName = user[ModelConstants.FirstName] + " " + user[ModelConstants.LastName];
    var email = user[ModelConstants.UserName];
    var initials = appManager.currentUserInitials();
    var paymentInfo = appManager.getPaymentInfo();

    var profileImageName = appManager.absoluteResourceForPath("Feed/feed_profile_placeholder_admin.png")

    var phoneNumberVerifyFeature = appManager.getFeatureForName('PhoneNumberVerify');
    var transactionHistoryFeature = appManager.getFeatureForName('TransactionHistory');

    var buttonWidth = 220;
    var margin = 4;

    var thisThing = this;

    return (
      <View style={[styles.container, {backgroundColor:generalColor}]}>
        { this.props.extras && this.props.extras.shouldHideActionBar ? null : <View style={styles.actionBarSpacer} /> }
        <View style={{flex:2}} />
        <View style={{flexDirection:'column', alignItems:'center', justifyContent:'center', marginBottom:40}}>
          <ReUpText appManager={appManager} style={{textAlign:'center', color:generalTitleColor}} isTitle={true}>
          {appManager.currentUserFullName()}
          </ReUpText>
          <ReUpText appManager={appManager} style={{textAlign:'center', color:generalTitleColor}}>
          {appManager.currentUser()[ModelConstants.UserName]}
          </ReUpText>
        </View>
        {
          typeof transactionHistoryFeature !== 'undefined' ?
            <ReUpButton isSecondary={true} appManager={appManager} style={{margin:margin, width:buttonWidth}} text={transactionHistoryFeature.data.title}
              onPress={()=>{appActions.requestFeatureName("TransactionHistory")}} />
          : null
        }
        {
          this.state.hasOptedInForEmail ?
            <ReUpButton appManager={appManager} isSecondary={true} style={{margin:margin, width:buttonWidth}} text={locManager.localizedStringForKey("UNSUBSCRIBE_BUTTON")}
              onPress={()=>
              {
                thisThing.unsubscribe();
              }} />
          :
            <ReUpButton appManager={appManager} isSecondary={true} style={{margin:margin, width:buttonWidth}} text={locManager.localizedStringForKey("SUBSCRIBE_BUTTON")}
              onPress={()=>
              {
                thisThing.subscribe();
              }} />
        }
        <View style={{flex:2}} />
        <ReUpButton isTertiary={true} appManager={appManager} text={locManager.localizedStringForKey("TERMS_AND_CONDITIONS_BUTTON")}
          onPress={()=>{thisThing.showTerms()}} />
        <View style={{height:20}} />
      </View>
    );
  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
  }
});

SimpleSettings.dataDependencies = ["Users", "Transactions"];

module.exports = SimpleSettings;



// WEBPACK FOOTER //
// ./src/SimpleSettings.js